export const AGENCY_REPORT_TABS = [
  {
    label: 'Vehicle Movement',
    id: 1,
    route: 'vehicle',
  },
  // {
  //   label: 'Person Movement',
  //   id: 2,
  //   route: 'person',
  // },
  {
    label: 'Vehicle Entry & Exit',
    id: 3,
    route: 'vehicle-entry-exit',
  },
  {
    label: 'Generated Reports',
    id: 4,
    route: 'generated',
  },
];

export const handleReportTabClick = (id, onClick) => {
  const tab = AGENCY_REPORT_TABS.find(item => item.id === id);
  if (!tab) {
    return;
  }
  onClick('statusRoute', {route: tab.route, id: tab.id});
};
